
import { defineComponent, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import { ScrollComponent } from "@/assets/ts/components/_ScrollComponent";
import { MenuComponent } from "@/assets/ts/components/MenuComponent";
import { version } from "@/core/helpers/documentation";
import { asideMenuIcons } from "@/core/helpers/config";
import MainMenuConfig from "@/core/config/MainMenuConfig";
import { CookieComponent } from "@/assets/ts/components";
import { useStore } from "vuex";
import { formatUserMenu } from "@/utils/userMenuUtil";

export default defineComponent({
  name: "kt-menu",
  components: {},
  setup() {
    const { t, te } = useI18n();
    const route = useRoute();
    const scrollElRef = ref<null | HTMLElement>(null);

    onMounted(() => {
      ScrollComponent.reinitialization();
      MenuComponent.reinitialization();
      if (scrollElRef.value) {
        scrollElRef.value.scrollTop = 0;
      }
    });

    const translate = (text) => {
      if (te(text)) {
        return t(text);
      } else {
        return text;
      }
    };

    const hasActiveChildren = (match) => {
      if (match) return route.path.split("/").includes(match);
      else return false;
    };
    const MenuConfig = ref(MainMenuConfig);
    const store = useStore();
    return {
      hasActiveChildren,
      MainMenuConfig,
      asideMenuIcons,
      MenuConfig,
      version,
      translate,
      store,
    };
  },
  mounted() {
    this.store
      /* .dispatch(Menu.findNavTree, {
        userName: CookieComponent.get("userName"),
        system: 1,
      })
      .then(async (res1) => {
        if (res1.code == 200) {
          const data = res1.data;
          await localStorage.removeItem("MainMenuConfig");
          localStorage.setItem(
            "MainMenuConfig",
            JSON.stringify(
              formatUserMenu(data, CookieComponent.get("roleGroup"))
            )
          );
        }
      }); */
    this.MenuConfig = JSON.parse(
      localStorage.getItem("MainMenuConfig") as string
    );
  },
});
